// import { useContext, useState } from 'react';
// import { Col as AntdCol } from 'antd';
// import { HomeContext } from 'contexts/home/context';
import { Col, Badge, Grid } from 'antd';
import { Row } from './styledComponent';
import { WelcomeMessage } from './WelcomeMessage';
import profile from 'assets/images/home/Profile-filled.svg';
import notification from 'assets/images/home/notifications.svg';
const { useBreakpoint } = Grid;
import { useNavigate } from 'react-router-dom';
import { useLifeInboxMessageCount } from 'all-in-one-shared-api';
import { useEffect, useState } from 'react';
import { useKeycloak } from 'all-in-one-react-keycloak';

type GreetingSectionProps = {
  alertsNum?: number;
  timesp?: string | number;
  policyHolderFirstName?: string;
};
// const ImageBlock = styled.img`
//   display: inline-block;
//   float: right;
// `;
const GreetingSection = (props: GreetingSectionProps) => {
  const navigate = useNavigate();
  // const { state } = useContext(HomeContext);
  const [randoms, setRandoms] = useState(Math.random());
  const { keycloak } = useKeycloak();
  const [counts, setCounts] = useState(0);
  const { timesp } = props;

  const { shouldFetch, data, error } = useLifeInboxMessageCount(
    'useLifeInboxMessageCount' + randoms,
    keycloak.token as string,
  );
  const { lg } = useBreakpoint();
  useEffect(() => {
    setRandoms(Math.random());
    shouldFetch(true);
  }, [shouldFetch, keycloak.token]);
  useEffect(() => {
    if (!timesp) {
      setRandoms(Math.random());
    } else {
      setRandoms(timesp as number);
    }
    shouldFetch(true);
  }, [shouldFetch, timesp]);

  useEffect(() => {
    setRandoms(timesp as number);
    shouldFetch(true);
  }, [shouldFetch, timesp]);
  useEffect(() => {
    if (data) {
      setCounts(parseInt(data.count));
    }
  }, [data, error]);
  return (
    <Row align="middle" justify="space-between" size={lg ? 'lg' : ''}>
      <WelcomeMessage alertsNum={props.alertsNum} policyHolderFirstName={props.policyHolderFirstName} />
      <Col span={6}>
        <Row justify="end">
          <Col sm={10} md={4} lg={4}>
            <img
              src={profile}
              alt=""
              style={{
                marginRight: '20px',
                cursor: 'pointer',
              }}
              onClick={() => navigate('/LifeAccount')}
            />
          </Col>
          <Col sm={{ span: 10, offset: 2 }} md={{ span: 4, offset: 0 }} lg={{ span: 4, offset: 0 }}>
            <Badge count={counts} color="#FF9F00">
              <img
                src={notification}
                alt=""
                style={{
                  cursor: 'pointer',
                }}
                onClick={() => navigate('/LifeInbox')}
              />
            </Badge>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default GreetingSection;
